import { ComposerActionHeader, ComposerActionRadioGroup } from 'components/composer/composer-actions-components';
import { FlowBody } from 'utils/flow';

const options = [
	{
		value: 'queue',
		label: 'Queue follow-ups',
		description: 'Hold until the current run finishes, then run in order.',
	},
	{
		value: 'steer',
		label: 'Steer active runs',
		description: 'Send into the current run to redirect it mid-flight.',
	},
];

const ComposerActionsDelivery = ({ disabled = false, mode = 'queue', onChange, onPrev }) => (
	<>
		<ComposerActionHeader title='Delivery' onPrev={onPrev} />
		<FlowBody>
			<ComposerActionRadioGroup
				idPrefix='composer-delivery'
				value={mode}
				options={options}
				disabled={disabled}
				onValueChange={onChange}
			/>
		</FlowBody>
	</>
);

export { ComposerActionsDelivery };
